import { useHistory, useParams } from "react-router-dom";
import '../../../../../../assets/css/providercustomers.css';
import '../../../../../../assets/css/bookings.css';
import * as common from "../../../../common/__redux/commonRedux";
import { connect } from "react-redux";
import back from "../../../../../../assets/icons/ic_caret_left.svg";
import { useEffect, useState } from "react";
import { useDictionary } from "../../../../../../utilities/hooks/UseDictionary";
import SimpleLoader from "../../../../common/SimpleLoader";
import {getExperienceById} from "../networking";
import { ToastContainer } from 'react-toastify';
import ConverterHelper from "../../../../../../utilities/helpers/Converters";
import {DateFormatHelper} from "../../../../../../utilities/helpers/DateFormatHelper";
import logo from "../../../../../../assets/images/experience_balnk.svg";
import ImageHelper from "../../../../../../utilities/helpers/ImageHelper";
import ProviderExperienceEditForm from "./tabs/ProviderExperienceEditForm";
import ExperiencePOIs from "./tabs/POIs/ExperiencePOIs";
import {NavigatorPaths} from "../../../../../../assets/dictionaries/NavigatorPaths";

const ProviderExperienceDetailPage = () => {
    const history = useHistory();
    const { id } = useParams();
    const dictionary = useDictionary();
    
    const [opacity, setOpacity] = useState(0);
    const [details, setDetails] = useState(null);
    const [showLoader, setShowLoader] = useState(true);
    const [tabIndex, setTabIndex] = useState(0);

    const dismiss = () => {
		history.goBack();
	};

    useEffect(() => {
        setTimeout(() => {
            setOpacity(1);
        }, 10);
        getExperienceData();
    }, []);

    const getExperienceData = async () => {
        setShowLoader(true);
        try {
            // Fetch data logic here
            const {data} = await getExperienceById(id)
            setDetails(data);
        } catch (error) {
            console.error('Error fetching experience data:', error);
        } finally {
            setShowLoader(false);
        }
    };

    const routeMap = {
		0: <ProviderExperienceEditForm formData={details?.data} onSubmitClicked={getExperienceData} />,
		1: <ExperiencePOIs details={details} />,
        // 2: <PoiExtra details={details} />,
	};
    const getProviderUrl = (provider) => `/applications?id=${details?.data.provider.id}`;

    const handleProviderRedirect = (details) => {
        history.push(`/${NavigatorPaths.applications.path}?id=${details.id}`);
    }

    return (
        <div
			className="provider-customer-calendar-container"
			style={{
				background: 'var(--background-color)',
				paddingTop: '0'
			}}
		>
            <div className="booking-details-wrapper" style={{ opacity: opacity }}>
                <div className={"booking-header-container provider-customer-header-container-details"}>
                    <div className="d-flex-center">
                        <div className="booking-detail-back-button" onClick={dismiss}>
                            <img src={back} />
                        </div>
                        <div className="d-flex-center provider-customer-name-image-wrapper">
                            {/*<div className="provider-customer-avatar">*/}
                            {/*    <ProfileImage name={details?.data.title} photo={details?.data.thumbnail_url} size={{width: 40, height: 40, fontSize: 14, lineHeight: 16}}/>*/}
                            {/*</div>*/}
                            <div className="custom-experience-image-container" style={{ marginLeft: 8, marginRight: 4 }}>
                                <img
                                    onError={(e) => {
                                        e.currentTarget.src = logo;
                                    }}
                                    src={details?.data.thumbnail_url ? ImageHelper.getFullImageUrl(details?.data.thumbnail_url) : logo}
                                    className="custom-experience-image"
                                />
                            </div>
                            <h2 className="title-main truncate" title={details?.data.title}>{details?.data.title}</h2>
                        </div>
                    </div>
                    <div className="booking-status-labels-container">
                        <a
                            href={getProviderUrl(details?.data.provider)}
                            onClick={e => {
                                if (
                                    !e.ctrlKey && !e.metaKey && !e.shiftKey &&
                                    e.button === 0
                                ) {
                                    e.preventDefault();
                                    // If you have a SPA navigation function, call it here:
                                    handleProviderRedirect(details?.data.provider, e);
                                }
                            }}
                            rel="noopener noreferrer"
                        >
                                {details?.data.provider.brand_name}
                        </a>

                        <h4>Total Reviews: {details?.data.total_reviews}</h4>
                        <h4>Avg Reviews: {ConverterHelper.normalizeAvgReview(details?.data.avg_reviews)}</h4>
                        <h4>Created At: {DateFormatHelper.monthTimeFormat(details?.data.created_at)}</h4>
                        <h4>Updated At: {DateFormatHelper.monthTimeFormat(details?.data.modified_at)}</h4>
                        {details?.data?.feed_id && (<h4>Feed Id: {details?.data?.feed_id}</h4>)}
                    </div>
                </div>
                <div className="booking-details-body">
					<div className="booking-details-container" style={{maxHeight: 'calc(100vh - 248px)'}}>
						<div className="settings-tab-bar">
							<div
								onClick={() => setTabIndex(0)}
								className={tabIndex === 0 ? "settings-tab settings-tab-active" : "settings-tab"}
							>
								{dictionary.experience}
							</div>
                            <div
                                onClick={() => setTabIndex(1)}
                                className={
                                    tabIndex === 1
                                        ? 'settings-tab settings-tab-active'
                                        : 'settings-tab'
                                }
                            >
                                {dictionary.pois} ({details?.point_of_interests.length})
                            </div>
						</div>
						{details ? routeMap[tabIndex] : null}
						<SimpleLoader showLoader={showLoader} />
					</div>
				</div>
            </div>
            <ToastContainer/>
        </div>
    )
}

export default connect(common.states, common.actions)(ProviderExperienceDetailPage);